<div class="card flex flex-col gap-4 p-4" [attr.data-testid]="testId()">
  <h4 class="font-semibold">{{ titleKey() | transloco }}</h4>
  <div class="mx-auto w-full max-w-[240px]">
    <p-chart
      type="doughnut"
      [data]="chartData()"
      [options]="chartOptions()"
      [plugins]="chartPlugins"
      [attr.data-testid]="testId() + '-canvas'"
    />
  </div>
  <ul
    class="mx-auto flex w-full max-w-[320px] flex-col gap-1"
    [attr.data-testid]="testId() + '-legend'"
  >
    @for (entry of legend(); track entry.key) {
      <li>
        <button
          type="button"
          class="legend-entry flex w-full items-center gap-3 rounded px-2 py-1 text-left text-sm"
          [class.legend-entry-hidden]="entry.hidden"
          [attr.aria-pressed]="!entry.hidden"
          [attr.data-testid]="testId() + '-legend-' + entry.key"
          (click)="toggleSegment(entry.key)"
        >
          <span
            class="h-3 w-3 shrink-0 rounded-sm"
            [style.background]="'var(' + entry.colorVar + ')'"
          ></span>
          <span class="grow">{{ entry.label }}</span>
          @if (isPercent()) {
            <span class="font-mono">{{ entry.share | appNumber: '1.1-1' }} %</span>
          } @else {
            <span class="font-mono">{{ entry.value | appNumber: digitsInfo() }}</span>
          }
        </button>
      </li>
    }
  </ul>
</div>
